import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { type DashboardFilters } from "./useLiveDashboardFilters";

export const useCurrentDayAdSpend = (filters: DashboardFilters) =>
  useQuery({
    queryKey: ["live_ad_spend_report", filters],
    queryFn: async () => await apiClient.getLiveAdSpendReportData({ queries: filters }),
  });
